import MetricIcon from './MetricIcon';
import Stack from '../Stack';
import styled from 'styled-components';

const PricePointMetricIconWrapper = styled(Stack).attrs(
    ({
        $space = '-.33em',
        $direction = 'row',
        $wrap = false,
        as = 'span',
    }) => ({
        $space,
        $direction,
        $wrap,
        as,
    }),
)`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
`;

function PricePointMetricIcon({ score, showEmpty, ...props }) {
    const numDollarSigns = score > 5 ? 3 : score > 0 ? 2 : score === 0 ? 1 : 0;
    return (
        <PricePointMetricIconWrapper {...props}>
            {new Array(numDollarSigns).fill('').map((s, idx) => (
                <MetricIcon
                    metricLabel="price point"
                    key={`price-point-${idx}`}
                />
            ))}
            {new Array(showEmpty ? 3 - numDollarSigns : 0)
                .fill('')
                .map((s, idx) => (
                    <MetricIcon
                        metricLabel="price point"
                        key={`price-point-empty-${idx}`}
                        css={`
                            color: ${({ theme }) => theme.gray_4};
                        `}
                    />
                ))}
        </PricePointMetricIconWrapper>
    );
}

export default PricePointMetricIcon;
